import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CommandResult } from '@cl/shared/models';
import { DocumentFileInspection } from '@cl/shared/models/documents/document-file-inspection.model';
import { FileMetadata } from '@cl/shared/models/file.model';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { DocumentFilePreviewModalComponent } from './document-file-preview-modal/document-file-preview-modal.component';

@Component({
    selector: 'cl-document-file-preview',
    standalone: false,
    templateUrl: './document-file-preview.component.html',
    styleUrl: './document-file-preview.component.less',
})
export class DocumentFilePreviewComponent implements OnChanges, OnDestroy {
    @Input() documentId: number;
    @Input() documentFileId: number;
    @Input() fileName: string;
    // Files of other modules: the calling module performs the requests. Without these inputs the modal uses the Documents API.
    @Input() loadInspection?: () => Promise<CommandResult<DocumentFileInspection>>;
    @Input() loadFileMetadata?: (entryName?: string) => Promise<CommandResult<FileMetadata>>;
    @Input() downloadFile?: (entryName?: string) => Promise<void>;

    private modal: NzModalRef | null = null;

    constructor(private modalService: NzModalService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (this.modal && (changes.documentId || changes.documentFileId || changes.fileName)) {
            this.close();
        }
    }

    ngOnDestroy(): void {
        this.close();
    }

    open(): void {
        if (this.modal) {
            return;
        }

        const modal = this.modalService.create({
            nzTitle: this.fileName || 'Dokumenta fails',
            nzContent: DocumentFilePreviewModalComponent,
            nzWidth: '90%',
            nzFooter: null,
            nzStyle: { top: '1rem' },
            nzData: {
                documentId: this.documentId,
                documentFileId: this.documentFileId,
                fileName: this.fileName,
                loadInspection: this.loadInspection,
                loadFileMetadata: this.loadFileMetadata,
                downloadFile: this.downloadFile,
            },
        });
        this.modal = modal;
        modal.afterClose.subscribe(() => {
            if (this.modal === modal) {
                this.modal = null;
            }
        });
    }

    close(): void {
        this.modal?.destroy();
        this.modal = null;
    }
}
